// Screen title: the route's titleKey by default; a screen can show a more specific name (e.g. "기록 상세") with
// usePageTitle(). The header title and document.title ("<page> · METIS Hub") follow it.
import { useEffect } from 'react';
import { create } from 'zustand';

const useTitleStore = create<{ override: string | null }>(() => ({ override: null }));

export function usePageTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) return;
    useTitleStore.setState({ override: title });
    return () => {
      if (useTitleStore.getState().override === title) useTitleStore.setState({ override: null });
    };
  }, [title]);
}

export const useTitleOverride = (): string | null => useTitleStore((s) => s.override);
